export const CHARACTER_STATES = [
  'Idle', 'Walk', 'Jump', 'Crouch', 'Attack', 'Guard', 'Hitstun', 'Knockdown',
  'Special', 'CounterAttack', 'Super', 'KO',
] as const;

export type CharacterState = (typeof CHARACTER_STATES)[number];

export const CHARACTER_STATE_PRIORITY: Readonly<Record<CharacterState, number>> = {
  Idle: 0,
  Walk: 1,
  Crouch: 2,
  Jump: 3,
  Guard: 4,
  Attack: 5,
  Special: 6,
  Super: 7,
  CounterAttack: 8,
  Hitstun: 9,
  Knockdown: 10,
  KO: 11,
};

export const isCharacterState = (value: unknown): value is CharacterState =>
  typeof value === 'string' && (CHARACTER_STATES as readonly string[]).includes(value);
